import { NoIcon, YesIcon } from 'components'
import {
  EntityList,
  EntityListProps,
  renderDate,
  renderStatusIcon,
} from 'components/EntityList'
import { Proving, User } from 'gql.generated'
import { Box } from 'grid'
import { ConstrainMode, SelectionMode } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

type ReadProvings_workers = any

export type ProvingNmfListProps = EntityListProps<ReadProvings_workers>

export const ProvingNmfList: React.FunctionComponent<ProvingNmfListProps> =
  React.memo(
    ({ items, ...props }) => {
      const { t } = useTranslation()

      const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
      const columns = React.useMemo(
        () => [
          fieldColumn('release', {
            onRender: (item: Proving, i, col) => {
              if (item && item.nmf && item.nmf.release === true) {
                return <YesIcon />
              } else {
                return <NoIcon />
              }
            },
            ungroupable: true,
          }),
          fieldColumn('transport', {
            onRender: (item: Proving, i, col) => {
              if (item && item.nmf && item.nmf.transport === true) {
                return <YesIcon />
              } else {
                return <NoIcon />
              }
            },
            ungroupable: true,
          }),
          fieldColumn('informed', {
            onRender: (item: Proving, i, col) => {
              if (item && item.nmf && item.nmf.informed === true) {
                return <YesIcon />
              } else {
                return <NoIcon />
              }
            },
            ungroupable: true,
          }),
          fieldColumn('status', {
            onRender: renderStatusIcon,
            getGroupValue: (item: Proving) => t(`enum.status.${item.status}`),
            minWidth: 40,
            maxWidth: 60,
            ungroupable: true,
          }),
          fieldColumn('dateFrom', {
            onRender: renderDate,

            ungroupable: true,
          }),
          fieldColumn('dateTo', {
            onRender: renderDate,
            ungroupable: true,
          }),
          fieldColumn('id', { ungroupable: true }),

          fieldColumn('title', {
            ungroupable: true,
          }),
          fieldColumn('provingGround.title', {
            onRender: (item, i, col) => {
              return `${item.provingGround!.title}, ${
                item.provingGround!.countryCode
              }`
            },
            isGrouped: true,
            getGroupValue: (item: Proving) =>
              `${item.provingGround!.title}, ${
                item.provingGround!.countryCode
              }`,
          }),
          fieldColumn('responsible', {
            onRender: (item, i, col) => {
              return (
                <div key={i}>
                  {item.responsible.map((user: User, a: any) => {
                    return (
                      <Box key={a} style={{ whiteSpace: 'pre-line' }}>
                        {user.name}
                      </Box>
                    )
                  })}
                </div>
              )
            },
            getGroupValue: (item: Proving) => {
              let result = ''
              if (item.responsible) {
                item.responsible.forEach((user: User) => {
                  result = `${result} ${user.name}`
                })
              }
              return result
            },
            ungroupable: true,
            minWidth: 105,
          }),
          fieldColumn('department', { ungroupable: true }),
        ],
        [fieldColumn, t]
      )

      return (
        <EntityList
          alternate={true}
          stickyHeader={true}
          selectionMode={SelectionMode.single}
          items={items}
          constrainMode={ConstrainMode.horizontalConstrained}
          columns={columns}
          sortHighestGroup={true}
          {...props}
        />
      )
    },
    (prevProps, nextProps) =>
      prevProps.items.length === nextProps.items.length ? true : false
  )
